import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * SoulBreadcrumb — quiet, editorial breadcrumb rail used above Soul
 * pages so users always know where they are without being shouted at.
 */
export default function SoulBreadcrumb({ items, testid = "soul-breadcrumb" }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid={testid}
      className="text-[11px] uppercase tracking-[0.24em] text-[hsl(var(--muted-foreground))] flex items-center gap-2 flex-wrap"
    >
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {it.to && !isLast ? (
              <Link
                to={it.to}
                className="hover:text-[hsl(var(--copper))] transition-colors"
              >
                {it.label}
              </Link>
            ) : (
              <span className={isLast ? "text-[hsl(var(--fg))]/85" : ""}>
                {it.label}
              </span>
            )}
            {!isLast && (
              <ChevronRight size={11} className="opacity-50" aria-hidden />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
